import { render, staticRenderFns } from "./LandlordDashboard.vue?vue&type=template&id=56e27dbb&scoped=true&"
import script from "./LandlordDashboard.vue?vue&type=script&lang=js&"
export * from "./LandlordDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LandlordDashboard.vue?vue&type=style&index=0&id=56e27dbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e27dbb",
  null
  
)

export default component.exports